import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST } from '../api';
import { SixdeeCRBTAPI } from '../sixdeecrbtapi';
import { PreviewToneRequest } from './previewtonerequest';

export class PreviewToneAPI extends SixdeeCRBTAPI<PreviewToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/
        return "";
    }

    getRequestData()
    {
        return "toneId=" + this.getRequest().getPreviewToneRequest().getToneId();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/previewtone/previewtoneapi.tsx